import { Property } from "./interfaces";

export const numeroAutorizacion: Property = {
  title: "Número de Autorización",
  type: "string",
};
